import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../globals';
import { LoginService } from '../service/apiservice/login.service';
import { UtilFunctions } from '../util-functions';
import { SessionUser } from '../service/modal/user';
declare var $;
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-paymentsuccess',
  templateUrl: './paymentsuccess.component.html',
  styleUrls: ['./paymentsuccess.component.css']
})
export class PaymentsuccessComponent implements OnInit {

  constructor(private router:Router,private global:Globals,private _loginService:LoginService) { }

  ngOnInit() {
    localStorage.setItem("Active Route",this.router.url);
    // window.location.reload();
    $(document).ready(function () {
      $("#paymentSuccessfullModel").modal({ backdrop: 'static', keyboard: false });
    });
    // this.refershSeession();
  }

  paymentSuccessOk(){
    $("#paymentSuccessfullModel").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
   this.router.navigate(['dashboard']);
  //  window.location.reload();
  }
  // refershSeession(){
  //   this._loginService.VerifyPassword(this.global.loggedUser.user.firstName,this.global.loggedUser.user.mobileNumber, this.global.loggedUser.user.otp, 'otpLogin')
  //   .subscribe((response) => {
  //     //  info_noti(response);
  //     Object.assign(this.global.loggedUser, response);
  //     console.log(this.global.loggedUser);
  //     UtilFunctions.setLocalStorage('user', JSON.stringify(response));
  //   },err=>{});
  // }
  // getUserInfoById(){
  //   this._loginService.getUserById(this.global.loggedUser.user.user_reg_id).subscribe(respons=>{
  //     // this.loggedUserInfo =SessionUser
  //     console.log(this.global.loggedUser);
  //     this.global.loggedUser.user=new SessionUser;
  //     Object.assign(this.global.loggedUser.user, respons);
  //     UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
  //     window.location.reload();
  //   },err=>{});
   
  // }



}
